import { Skeleton, Grid } from "@mui/material";
export const SkeletonsHorizontalCard = ({ length }) => {
  return (
    <div className="w-full flex">
      <Grid container spacing={2}>
        {[...Array(length)].map((_, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
            <Skeleton
              className="w-full"
              key={index}
              variant="rectangular"
              height={160}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
